import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { SolutionIntro } from './components/SolutionIntro';
import { HowItWorks } from './components/HowItWorks';
import { Gallery } from './components/Gallery';
import { UseCases } from './components/UseCases';
import { ShynessObjection } from './components/ShynessObjection';
import { WhatYouGet } from './components/WhatYouGet';
import { Purpose } from './components/Purpose';
import { Bonuses } from './components/Bonuses';
import { Reframe } from './components/Reframe';
import { Testimonials } from './components/Testimonials';
import { MissionTransition } from './components/MissionTransition';
import { FinalOffer } from './components/FinalOffer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3mk852v2dm5by">
      <SiteHeader data-id="element-1" data-mp="3rcj6k2crlz6m" />
      <main data-id="element-2" data-mp="3rbzomln47asl">
        <Hero data-id="element-3" data-mp="3rdatypw7kqlt" />
        <Problem data-id="element-4" data-mp="3rcswxr1q28cu" />
        <SolutionIntro data-id="element-5" data-mp="3reccfffk0fdk" />
        <HowItWorks data-id="element-6" data-mp="5otf64sd496" />
        <Gallery data-id="element-7" data-mp="6817u0q2c9h" />
        <UseCases data-id="element-8" data-mp="4n6a3ahwrb3" />
        <ShynessObjection data-id="element-9" data-mp="56l3b4umzkw" />
        <WhatYouGet data-id="element-10" data-mp="2zl3brl12165b" />
        <Purpose data-id="element-11" data-mp="2zlli5ahfl0qy" />
        <Bonuses data-id="element-12" data-mp="2zm4v0cs84yy4" />
        <Reframe data-id="element-13" data-mp="2zmo7vf30ox5a" />
        <Testimonials data-id="element-14" data-mp="2zn66ujh2dpgw" />
        <MissionTransition data-id="element-15" data-mp="33mf2jtvnzxf3" />
        <FinalOffer data-id="element-16" data-mp="33nq6put0v76q" />
        <Guarantee data-id="element-17" data-mp="33n6xd2hftr4b" />
        <Faq data-id="element-18" data-mp="33orla998ybt7" />
        <FinalClose data-id="element-19" data-mp="38lrq6gud18iq" />
      </main>
      <Footer data-id="element-20" data-mp="38li619vzxvky" />
    </div>;
}